"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _button = require("@design/ui/button");
var _materialSymbols = require("@design/icons/material-symbols");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function IssueDetailHeader(_ref) {
  var title = _ref.title,
    onBack = _ref.onBack,
    onEdit = _ref.onEdit,
    _ref$editLabel = _ref.editLabel,
    editLabel = _ref$editLabel === void 0 ? "Edit" : _ref$editLabel;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "w-full h-[35px] flex flex-row items-center gap-4 self-stretch flex-none",
    "data-sentry-component": "IssueDetailHeader",
    "data-sentry-source-file": "IssueDetailHeader.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      type: "button",
      variant: "ghost",
      size: "icon-sm",
      "aria-label": "Back",
      onClick: onBack,
      "data-sentry-element": "Button",
      "data-sentry-source-file": "IssueDetailHeader.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowBackIcon, {
        "data-sentry-element": "ArrowBackIcon",
        "data-sentry-source-file": "IssueDetailHeader.tsx"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      title: title,
      className: "flex flex-1 items-center truncate text-label-sm uppercase tracking-wide text-foreground-muted",
      children: title
    }), onEdit && /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      type: "button",
      variant: "link",
      size: "sm",
      onClick: onEdit,
      "aria-label": "Edit rule",
      children: editLabel
    })]
  });
}
var _default = exports.default = IssueDetailHeader;